import { Orion } from '../orion';
export class UrlBuilder {
    static getResourceBaseUrl(model) {
        return Orion.getApiUrl() + '/' + model.prototype.$resource();
    }
    static getResourceUrl(model) {
        return (UrlBuilder.getResourceBaseUrl(model.constructor) +
            `/${model.$getKey()}`);
    }
    static getRelationResourceUrl(parent, relationConstructor) {
        return (UrlBuilder.getResourceUrl(parent) + '/' + relationConstructor.prototype.$resource());
    }
}
//# sourceMappingURL=urlBuilder.js.map